module.exports = __webpack_public_path__ + "static/media/alicante-12.6ffb3824.jpg";